import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { QuestionAnswerItemSectionComponentProps } from './types';

export const QuestionAnswerItemGeneratedSection: FC<
  QuestionAnswerItemSectionComponentProps
> = () => {
  return <NodeViewContent className="question-answer-item-generated" />;
};
